import store from '../'

let resource = store.defineResource({
  name: "reviews",
  relations: {
    belongsTo: {
      userAssignments: [
        {
          localKey: 'reviewerUserAssignmentId',
          localField: 'reviewerUserAssignment',
          parent: true
        }, {
          localKey: 'revieweeUserAssignmentId',
          localField: 'revieweeUserAssignment'
        }
      ]
    },
    hasOne: {
      users: [
        {
          localKey: 'revieweeUserId',
          localField: 'revieweeUser'
        },
        {
          localKey: 'reviewerUserId',
          localField: 'reviewerUser'
        }
      ],
      rubrics: {
        localKey: "rubricsId",
        localField: "rubrics"
      }
    },
  },
  computed: {
    totalScore: {
      get () {
        if (this.ratings) {
          return _.sum(this.ratings);
        }
      }
    },
    averageScore: {
      get () {
        if (this.ratings) {
          return this.totalScore / this.rubrics.criteria.length
        }
      }
    },
    reviewBy: {
      get () {
        return _.get(this, "reviewerUser.nickname") || "Anonymous";
      }
    },
    reviewOf: {
      get () {
        return _.get(this, "revieweeUser.nickname") || "Anonymous";
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/reviews.js